"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Abstraction of Material UI's Checkbox control
 * 
 * Original author @heron-web/material (no longer maintained)
 */const Checkbox = props => {
  /**
   * Value changed.
   *
   * @param {Event} e
   * @return {void}
   */
  const handleChange = e => {
    props.onChange?.(!props.checked, props.name, e);
  };
  const renderCheckBox = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
      ...props,
      checked: props.checked,
      color: props.color,
      disabled: props.disabled,
      indeterminate: props.indeterminate,
      onChange: handleChange,
      required: props.required,
      size: props.size
    });
  };
  if (props.label) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
      control: renderCheckBox(),
      label: props.label
    });
  } else {
    return renderCheckBox();
  }
};
Checkbox.propTypes = {
  checked: _propTypes.default.bool,
  color: _propTypes.default.oneOf(["primary", "secondary"]),
  disabled: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  required: _propTypes.default.bool,
  size: _propTypes.default.oneOf(["medium", "small"])
};
Checkbox.defaultProps = {
  checked: false,
  color: "primary",
  disabled: false,
  indeterminate: false,
  required: false,
  size: "medium"
};
var _default = exports.default = Checkbox;